query NotificationCycleTimeZones($orderBy: [TimeZonesOrderBy!]) {
  timeZones(orderBy: $orderBy) {
    nodes {
      id
      standardTimeZoneCode
    }
  }
}
